import React from 'react';
import { Route } from 'react-router-dom';
import ManishProfile from '../Profiles/ManishProfile';
import BarryHasenkopfProfile from '../Profiles/BarryHasenkopfProfile';
import KennyDaughertyProfile from '../Profiles/KennyDaughertyProfile';
import JenniferBarfieldProfile from '../Profiles/JenniferBarfieldProfile';
import BriannaDouglasProfile from '../Profiles/BriannaDouglasProfile';
import BeckyHermanProfile from '../Profiles/BeckyHermanProfile';
import AmiraBevillProfile from '../Profiles/AmiraBevillProfile';
import KirbyGodseyProfile from '../Profiles/KirbyGodseyProfile';
import DarrelColsonProfile from '../Profiles/DarrelColsonProfile';
import ChrisSchulerProfile from '../Profiles/ChrisSchulerProfile';
import JessicaThompsonProfile from '../Profiles/JessicaThompsonProfile';
import DinaAlkikiProfile from '../Profiles/DinaAlkikiProfile';
import JeanCallaghanProfile from '../Profiles/JeanCallaghanProfile';
import LincolnMehtaProfile from '../Profiles/LincolnMehtaProfile';

export const profileRoutes = [
  <Route key="manish" path="/profile/manish" element={<ManishProfile />} />,
  <Route key="barry-hasenkopf" path="/profile/barry-hasenkopf" element={<BarryHasenkopfProfile />} />,
  <Route key="kenny-daugherty" path="/profile/kenny-daugherty" element={<KennyDaughertyProfile />} />,
  <Route key="jennifer-barfield" path="/profile/jennifer-barfield" element={<JenniferBarfieldProfile />} />,
  <Route key="brianna-douglas" path="/profile/brianna-douglas" element={<BriannaDouglasProfile />} />,
  <Route key="becky-herman" path="/profile/becky-herman" element={<BeckyHermanProfile />} />,
  <Route key="amira-bevill" path="/profile/amira-bevill" element={<AmiraBevillProfile />} />,
  <Route key="kirby-godsey" path="/profile/kirby-godsey" element={<KirbyGodseyProfile />} />,
  <Route key="darrel-colson" path="/profile/darrel-colson" element={<DarrelColsonProfile />} />,
  <Route key="chris-schuler" path="/profile/chris-schuler" element={<ChrisSchulerProfile />} />,
  <Route key="jessica-thompson" path="/profile/jessica-thompson" element={<JessicaThompsonProfile />} />,
  <Route key="dina-alkiki" path="/profile/dina-alkiki" element={<DinaAlkikiProfile />} />,
  <Route key="jean-callaghan" path="/profile/jean-callaghan" element={<JeanCallaghanProfile />} />,
  <Route key="lincoln-mehta" path="/profile/lincoln-mehta" element={<LincolnMehtaProfile />} />,
];

